import { Component, OnInit } from '@angular/core';
import { concatMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoginModel } from 'src/app/core/models/login.model';
import { LoginResultModel } from 'src/app/core/models/login-result.model';
import { RouteStateService } from 'src/app/core/services/route-state.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginInfo: LoginModel = new LoginModel;
  isLoading: boolean = false;
  hasError: boolean = false;
  errorMessage: string = '';
  tenantCode: string = '';

  filename;

  constructor(
    private authService: AuthService,
    private routeStateService: RouteStateService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
  ) {  
    
    // this.route.params.subscribe(params => {
    //   if(params.tenantcode){
    //     this.loginInfo.TenantCode = params.tenantcode.slice(0, 5);
    //     this.tenantCode = this.loginInfo.TenantCode;
    //   }
    // });  
    this.loginInfo.TenantCode = '27200';
    this.tenantCode = this.loginInfo.TenantCode;  
  }

  ngOnInit(): void {
    this.filename = new Date().getTime();

    this.shouldRememberMe();
  }

  shouldRememberMe(){
    this.authService.shouldRememberMe().subscribe(
      result => {
        if(result.Success){
          this.loginInfo.RememberMe = true;
          this.loginInfo.TenantCode = "27200";//result.TenantCode;
          this.loginInfo.Username = result.UserName;
          this.loginInfo.Password = result.Password;
        }
        // else{
        //   this.loginInfo.RememberMe = false;
        //   this.loginInfo.Username = result.UserName;
        //   this.loginInfo.Password = result.Password;
        // }
      }
    )
  }

  login() {
    this.hasError = false;
    this.errorMessage = '';
    this.isLoading = true;
    this.authService.login(this.loginInfo)
      .subscribe(
        (req) => {
          this.clearLocalStorage();
          this.isLoading = false;
          this.authService.setIdentity(req.access_token, req.user, req.role, req[".expires"]);
          this.authService.storeData('TenantCode', this.loginInfo.TenantCode.toString());
          this.authService.storeData('UserPhoto', req.user_photo);
          this.authService.toggleForceChangePassword(req.pass);
          this.authService.checkNotification(req);

          if(req.refresh_token){
            this.authService.storeData('refresh_token', req.refresh_token);
          }

          this.redirectUser();
        },
        (err) => {
          var result: LoginResultModel = err.error as LoginResultModel;
          if(result == null || result.error_description == null || result.error_description == '')
            this.errorMessage = 'Giriş başarısız. Lütfen tekrar deneyiniz.';
          else
            this.errorMessage = result.error_description;
          this.isLoading = false;
          this.hasError = true;
        }
      )
  }

  redirectUser(){
    if (this.authService.hasRole('ADMIN'))
      this.router.navigate(['/yonetim']);
    else if (this.authService.hasRole('INSTRUCTOR'))
      this.router.navigate(['/egitmen']);
    else if (this.authService.hasRole('STUDENT'))
      this.router.navigate(['/ogrenci']);
  }
  
  clearLocalStorage() {

    var topicA = localStorage.getItem("topic_user"); // Pass a key name to get its value.
    var topicB = localStorage.getItem("topic_tenant"); // Pass a key name to get its value.
    var topicC = localStorage.getItem("topic_all");

    localStorage.clear();

    localStorage.setItem("topic_user", topicA); // Pass a key name to get its value.
    localStorage.setItem("topic_tenant", topicB); // Pass a key name to get its value.
    localStorage.setItem("topic_all", topicC);

  }

  onImgError(event){
    event.target.src = './assets/logo/logo.svg?v=' + this.filename ;
  }
}
